import { Map } from "immutable";
import * as React from "react";
import 'intersection-observer';
import { InView } from 'react-intersection-observer';
import { Action, IOWidget, mk_widget, AsyncState, Pair } from "widgets-for-react";
import * as Plyr from 'react-plyr';
import { CMSState, ImageSize, Link } from "../../../../cms/blocks/types.gen";
import { blockInviewHandler } from "../../../../drupal/rendering/inview_utils.mod";
import { getClassName, link } from "../../../../cms/blocks/utils.gen";
import { ImageContainer } from "../../../../cms/blocks/widgets/ImageContainer.gen";
import { ExtraImages } from "../../../utils/extra_images.mod";
import { PublicSite_CustomPageData } from "../../../application.mod";
import { PublicSiteState } from "../../../../../public_site.main.mod";
import { ParsedMediaVideo, ParsedMediaImage } from "../../../../drupal/types_and_parser/types";
import { CookieSensitiveContentWrapper } from "../../../../cms/blocks/cookiebar.mod";
import { setCookie } from "../../../../cms/blocks/cookiebar.utils.mod";

export type mediaBlockProps = {
  blockIndex: number
  media: ParsedMediaImage | ParsedMediaVideo
  caption?: string
  background?: "grey" | "white" | "orange"
  useCookieBar: boolean
  cookiePlaceholder: JSX.Element | string
  cookieButton: string
  get_default_data_src:(() => ImageSize<ExtraImages>)
  get_default_data_srcset:(() => Pair<ImageSize<ExtraImages>, string>[])
}

export type MediaBlockStyle = Partial<{
  block_classname: string
  media_classname: string
  visual_classname: string
  image_classname: string
  video_classname: string
  figcaption_classname: string
  caption_classname: string
  placeholder_classname: string
  cookies_classname: string
  cookies_inner_classname: string
  cookies_text_classname: string
  cookies_clickable_classname: string
}>

export function mediaBlock<customBlockData>(
  props: mediaBlockProps,
  options?: { style: MediaBlockStyle; key?: string }
): (s:CMSState<customBlockData, ExtraImages, PublicSite_CustomPageData>) => IOWidget<PublicSiteState, Action<CMSState<customBlockData,ExtraImages, PublicSite_CustomPageData>>> {
    return (s: CMSState<customBlockData,ExtraImages, PublicSite_CustomPageData>) => (public_state:PublicSiteState) =>
    mk_widget({
      run: _ => {
        return (
          // <figure className={`block block--media${props.background == 'grey' ? " block--color" : props.background == 'orange' ? " block--orange" : ""}`}>
          <figure className={`block block--media`}>
            <div className="block__inner container container--s grid--block">
              <div className='block__media'>
              {props.media != null && props.media.bundle === "image"
                ? (s.images.has(props.media.field_media_image.image.id)
                    ? (<div className={getClassName(options, "media_classname", "")}>
                      {ImageContainer(
                        s.images.get(props.media.field_media_image.image.id) as AsyncState<Map<ImageSize<ExtraImages>, string>>,
                        'media',
                        getClassName(options, "image_classname", "w-100"),
                        props.media.field_media_image.alt,
                        props.get_default_data_src,
                        props.get_default_data_srcset
                      ).run(_ => { })}
                    </div>)
                    : (<div className={getClassName(options, "placeholder_classname", "")} aria-hidden="true"></div>)
                  )
                : props.media != undefined && props.media.bundle === "video" && (
                    <div className={getClassName(options, "media_classname", "text-center")}>
                      {props.useCookieBar
                        ? (<CookieSensitiveContentWrapper
                            groupId={4}
                            options={{style:options && options.style
                              ? {
                                  cookies_classname: options.style.cookies_classname,
                                  cookies_inner_classname: options.style.cookies_inner_classname,
                                  cookies_text_classname: options.style.cookies_text_classname,
                                  cookies_clickable_classname: options.style.cookies_clickable_classname
                                }
                              : undefined
                            }}
                            placeholder={
                              <div className="media__placeholder cookie--message">
                                <div className="media__inner">
                                  <p>{props.cookiePlaceholder}</p>
                                  {/* <a className='optanon-toggle-display' onClick={() => Optanon.ToggleInfoDisplay()}>{props.cookieButton}</a> */}
                                  <button className='button button--secondary cookie--accept' onClick={() => {
                            setCookie('so_you_accepted_the_cookies?', 'yes_i_did', 100000)
                            window.location.reload()
                          }}>{props.cookieButton}</button>
                                </div>
                              </div>
                            }
                            button={props.cookieButton}
                          >
                            <Plyr
                              onPlay={() => window.dataLayer.push({
                                event: "event.refresco", category: "Video", action: "Start", label: window.location.pathname
                              })}
                              onPause={() => window.dataLayer.push({
                                event: "event.refresco", category: "Video", action: "Pause", label: window.location.pathname
                              })}
                              type={props.media.field_media_video_embed_field.type}
                              videoId={props.media.field_media_video_embed_field.id}
                            />
                          </CookieSensitiveContentWrapper>)
                        : <Plyr
                            onPlay={() => window.dataLayer.push({
                              event: "event.refresco", category: "Video", action: "Start", label: window.location.pathname
                            })}
                            onPause={() => window.dataLayer.push({
                              event: "event.refresco", category: "Video", action: "Pause", label: window.location.pathname
                            })}
                            type={props.media.field_media_video_embed_field.type}
                            videoId={props.media.field_media_video_embed_field.id}
                          />
                      }
                    </div>
                  )
              }

              </div>
              {props.caption  && (
                <figcaption className='block__figcaption media__figcaption'>
                    <p className='media__caption text--s'>
                      {props.caption}
                    </p>
                </figcaption>
              )}
            </div>
          </figure>
        )
      },
    })
}
